import chatttSDK from 'services/chattt';

const isInClient = chatttSDK !== undefined;

const authorizationCache = {
  storage: isInClient ? sessionStorage : localStorage,
  cacheKey: `@${import.meta.env.VITE_NAME}-token`,
};

export default authorizationCache;
